
import { Component, OnInit, Inject, ChangeDetectorRef } from "@angular/core";
import { Router } from "@angular/router";
import { UserIdleService } from "angular-user-idle";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

@Component({
  selector: "app-timeout",
  templateUrl: "./timeout.component.html",
  styleUrls: ["./timeout.component.css"],
})
export class TimeoutComponent implements OnInit {
  counter: any;
  interval: any;
  timeLeft: any;

  constructor(
    private userIdle: UserIdleService,
    private router: Router,
    private dialogref: MatDialogRef<TimeoutComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private changeDetectorRef: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    // Start watch when time is up.
    this.counter = 60;
    this.startTimer();
    this.changeDetectorRef.detectChanges();
  }

  startTimer(): any {
    this.interval = setInterval(() => {
      if (this.counter > 0) {
        this.counter--;
      } else if (this.counter > -2 && this.counter < 0) {
        this.counter = 0;
        this.close();
      }
    }, 1000);
  }

  stop(): any {
    this.userIdle.stopTimer();
  }

  close(): void {
    //this.restart();
    this.stop();
    this.stopWatching();
    this.dialogref.close();
    this.logout();
  }

  continue(): void {
    this.restart();
    this.stop();
    this.startWatching();
    localStorage.setItem("appIdleStatus", "false");
    localStorage.setItem("appLastActivity", Date.now().toString());
    this.dialogref.close();
  }

  stopWatching(): any {
    this.userIdle.stopWatching();
  }

  startWatching(): any {
    this.userIdle.startWatching();
  }

  restart(): any {
    this.userIdle.resetTimer();
  }

  private logout(): void {
    this.router.navigateByUrl("login");
    localStorage.removeItem("userinfo");
    localStorage.removeItem("token");
    localStorage.removeItem("loggedInUser");
    localStorage.removeItem("userRole");
    localStorage.removeItem("agenceinso");
    localStorage.removeItem("agence");
    // localStorage.removeItem('session');
    localStorage.removeItem("authority");
    this.router.navigateByUrl("login");
    this.reloadComponent();
  }

  reloadComponent(): any {
    // const currentUrl = this.router.url;
    const currentUrl = "login";
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = "reload";
    this.router.navigate([currentUrl]);
  }
}
